<template>
    <div>
        <div class="ajFlex c-page-top">
            <div class="c-page-title">添加用户角色</div>
            <Button type="info" ghost @click="handleBack">返回</Button>
        </div>
        <div class="form-list form-wrapper">
            <Button class="long-addBtn" size="large" long type="dashed" :loading="loading" @click="handleSubmit('formInline')">确认提交</Button>
            <Form  ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="150" label-position="right">
                <Row :gutter="24">
                    <Col span="12">
                        <FormItem label="角色名称：" prop="roleName">
                            <Input v-model="formInline.roleName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <!--<Col span="12">-->
                        <!--<FormItem label="添加时间：" prop="auditor">-->
                            <!--<Input readonly v-model="formInline.auditor" placeholder="请输入"></Input>-->
                        <!--</FormItem>-->
                    <!--</Col>-->
                </Row>
                <Table :columns="tableColumns" :data="tableData"
                       @on-selection-change="handleSelect"
                       ref="selection" highlight-row>
                    <template slot-scope="{ row, index }" slot="menus">
                        <Button @click="handleMenus(row.id,row.menus,index)" size="small" type="primary" icon="md-add"></Button>
                    </template>
                    <template slot-scope="{ row, index }" slot="authCode">
                        <RadioGroup v-model="tableData[index].authCode">
                            <Radio label="manage">管理</Radio>
                            <Radio label="view">查看</Radio>
                        </RadioGroup>
                    </template>
                </Table>
            </Form>
        </div>
        <Modal v-model="modelMenus" footer-hide class-name="centerModal" width="300">
            <p slot="header">
                <span>分配菜单</span>
            </p>
            <div class="menus-tree">
                <!--<div class="">-->
                    <!--<Button class="light_blueBtn" @click="setMenu" style="margin-right: 15px">确定</Button>-->
                    <!--<Button class="light_blueBtn" @click="modelMenus=false">取消</Button>-->
                <!--</div>-->
                <el-tree
                        ref="tree"
                        :data="treeData"
                        :props="defaultProps"
                        highlight-current
                        show-checkbox
                        node-key="id"
                        @check="handleCheck">
                    <!--
                        :default-expanded-keys="[]"
                        :default-checked-keys="[]"-->
                </el-tree>
            </div>
        </Modal>
    </div>
</template>
<style>
    .menus-tree{
        height: 320px;
        overflow: auto;
    }
</style>
<script>
    export default {
        components:{

        },
        data(){
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                treeData: [
                    // {
                    //     id: 4,
                    //     label: '',
                    //     children: [],
                    // }
                ],
                modelMenus:false,
                loading:false,
                formInline:{
                    roleName:'',
                },
                permissions:[],
                ruleInline: {
                    roleName: [
                        { required: true,  message: '角色名称不能为空', trigger: 'blur' }
                    ],
                },
                tableColumns:[
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '系统名称' ,
                        key: 'name',
                    },
                    {
                        title: '菜单',
                        slot: 'menus',
                    },
                    {
                        title: '权限',
                        slot: 'authCode',
                    }
                ],
                tableData:[],
                id:'',
                // 当前表格下标
                curIndex:'',
            };
        },
        computed:{

        },
        created(){
            this.id= this.$route.query.id;
            this.getPageData();
        },
        watch: {

        },
        methods: {
            // 表格选中
            handleSelect(selection){
                // console.log(selection)
                for (let j=0;j<this.tableData.length;j++){
                    if(selection.length===0){
                        this.tableData[j]._checked=false;
                        continue;
                    }
                    for (let i=0;i<selection.length;i++){
                        if(selection[i].id===this.tableData[j].id){
                            this.tableData[j]._checked=(selection[i].id===this.tableData[j].id);
                            break;
                        }else {
                            this.tableData[j]._checked=false;
                        }
                    }
                }
            },
            // 树结构复选框选中
            handleCheck(curr,checked){
                this.tableData[this.curIndex].menus=checked.checkedKeys;
                // // 选中的key
                // console.log(checked.checkedKeys);
                // // 选中的节点
                // console.log(checked.checkedNodes);
                // let arr=checked.checkedNodes.filter((item)=>{
                //     return !item.children;
                // });
                // // 选中的子节点 不包含父节点
                // console.log(arr);
            },
            // 设置菜单
            handleMenus(id,menus,index){
                this.curIndex=index;
                this.axios({
                    method: 'get',
                    url: `/menu/loadMenuTree/${id}`,
                    params:{
                        loginType:localStorage.getItem('loginType'),
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.treeData=response.data.data;
                        this.modelMenus=true;
                        // console.log(menus);
                        this.$refs.tree.setCheckedKeys(menus);
                    }
                });
            },
            /* 获取页面信息 */
            getPageData(){
                new Promise((resolve, reject)=>{
                    this.axios({
                        method: 'get',
                        url:'/menu/menuList',
                        params:{
                            loginType:localStorage.getItem('loginType')
                        }
                    }).then((response)=>{
                        if(response.data){
                            response.data.forEach(item=>{
                                item.menus=[];
                                item.authCode='view';
                                item._checked=false;
                            });
                            this.tableData=response.data;
                            resolve();
                        }
                    });
                }).then(()=>{
                    if(this.id){
                        this.axios({
                            method: 'get',
                            url:`/role/permissions/${this.id}`,
                        }).then((response)=>{
                            if(response.data.success){
                                this.formInline=response.data.data;
                                let arr=response.data.data.permissions;
                                for (let i=0;i<arr.length;i++){
                                    for (let j=0;j<this.tableData.length;j++){
                                        if(arr[i].id===this.tableData[j].id){
                                            this.tableData[j]._checked=true;
                                            this.tableData[j].menus=arr[i].menus;
                                            this.tableData[j].authCode=arr[i].authCode;
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                    }
                });
            },
            handleBack(){
                this.$router.go(-1);
            },
            /*提交*/
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let data={
                            loginType:localStorage.getItem('loginType'),
                        };
                        Object.assign(data,this.formInline);
                        let permissions=[];
                        this.tableData.forEach(item=>{
                            if(item._checked){
                                permissions.push(item);
                            }
                        });
                        data.permissions=permissions;
                        let url='/role/addRole';
                        if(this.id){
                            url='/role/updateRole';
                        }
                        this.loading=true;
                        this.axios({
                            method: 'post',
                            url: url,
                            data: data,
                        }).then((response) => {
                            this.loading=false;
                            if(response.data.success){
                                this.$Message.success('提交成功!');
                                this.$router.go(-1);
                            }else {
                                this.$Message.warning(response.data.message);
                                // this.$Modal.warning({
                                //     title:'提示',
                                //     content:response.data.message,
                                // });
                            }
                        }).catch( ()=> {
                            this.loading=false;
                        });

                    } else {
                        this.$Message.error('表单验证未通过!');
                    }
                });
            }
        }
    };
</script>
